// extracted by mini-css-extract-plugin
module.exports = {"title":"RemoveGroupModal_title_3upqF","pureLabelButton":"RemoveGroupModal_pureLabelButton_1NvBW"};